import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { StatusItemAnalise } from '../../enums/analise.enum';
import { getBgColorAprovacao } from '../../pages/Processo/components/ColorsAnalise';
export var AnaliseDocumentoStatusComponent = function (_a) {
    var analiseDocumento = _a.analiseDocumento, children = _a.children;
    if (!analiseDocumento) {
        return children;
    }
    return (_jsx(Box, { sx: {
            borderRadius: 2,
            padding: 2,
            backgroundColor: getBgColorAprovacao(analiseDocumento === null || analiseDocumento === void 0 ? void 0 : analiseDocumento.status),
        }, children: _jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-start',
            }, children: [_jsxs(Stack, { sx: {
                        mr: 2,
                        display: 'flex',
                        flexDirection: 'row',
                    }, children: [(analiseDocumento === null || analiseDocumento === void 0 ? void 0 : analiseDocumento.status) === StatusItemAnalise.APROVADO && (_jsx(CheckCircleIcon, { color: "success" })), (analiseDocumento === null || analiseDocumento === void 0 ? void 0 : analiseDocumento.status) === StatusItemAnalise.REPROVADO && (_jsx(CancelIcon, { color: "error" }))] }), _jsxs(Stack, { sx: {
                        flexGrow: 1,
                        gap: 1,
                        p: 1,
                        borderRadius: 1,
                        border: '1px solid #E4E4E4',
                        bgcolor: '#F5F5F5',
                    }, children: [_jsx(Box, { sx: { flexGrow: 1 }, children: children }), (analiseDocumento === null || analiseDocumento === void 0 ? void 0 : analiseDocumento.justificativa) && (_jsxs(Box, { sx: { mt: 2 }, children: [_jsx(Typography, { variant: "caption", color: "textSecondary", children: "Motivo da reprova\u00E7\u00E3o:" }), _jsx(Box, { sx: {
                                        border: '1px solid rgba(0, 0, 0, 0.38)',
                                        borderRadius: 1,
                                        px: 2,
                                        py: 1,
                                        whiteSpace: 'pre-wrap',
                                        overflowX: 'auto',
                                        overflowY: 'auto',
                                        minHeight: '100px',
                                        height: '100px',
                                        maxHeight: '500px',
                                        resize: 'vertical',
                                        color: 'text.secondary',
                                    }, children: analiseDocumento === null || analiseDocumento === void 0 ? void 0 : analiseDocumento.justificativa })] }))] })] }) }));
};
